export class DocumentTypeCalculationFieldApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async editDocumentTypeCalculationField({ documentTypeCalculationFieldId, ...body }) {
    return this.#http.put(`/DocumentTypeCalculationField/${documentTypeCalculationFieldId}`, body);
  }

  async deleteDocumentTypeCalculationField({ documentTypeCalculationFieldId }) {
    return this.#http.delete(`/DocumentTypeCalculationField/${documentTypeCalculationFieldId}`);
  }

  async getDocumentTypeCalculationField(params) {
    return this.#http.get('/DocumentTypeCalculationField', { params });
  }

  /**
   * POST /DocumentTypeCalculationField/evaluate — evaluates a document type's calculation fields
   * against unsaved `{ fieldId, value }` extraction-field values; nothing is persisted.
   */
  async evaluateDocumentTypeCalculationFields({ documentTypeId, values }) {
    return this.#http.post('/DocumentTypeCalculationField/evaluate', { documentTypeId, values });
  }

  async createDocumentTypeCalculationField(body) {
    return this.#http.post('/DocumentTypeCalculationField', body);
  }
}
